import script from "./Transport.vue?vue&type=script&setup=true&lang=js"
export * from "./Transport.vue?vue&type=script&setup=true&lang=js"

import "./Transport.vue?vue&type=style&index=0&id=fd9518a4&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd9518a4"]])

export default __exports__